<mat-toolbar class="header" fxLayout="row wrap" style="height: max-content;">

  <button id="menuBtn" mat-icon-button (click)="onSidenavClose()" class="material-icons">
    <mat-icon class="white-icon">menu</mat-icon>
  </button>

  <div class="header-date" fxLayout="row wrap" fxFlexOffset="auto" style="display: flex; align-items: center;">

    <div *ngIf="isKenmu">
      <div><button mat-icon-button (click)="onClick()"><mat-icon
            style="vertical-align: middle; margin-right: 5px; display: inline-block;">account_circle</mat-icon></button>{{
        userOrganizationInfo.cmpnyName }}</div>
    </div>

    <div *ngIf="!isKenmu">
      <div><mat-icon fontSet="material-icons-outlined"
          style="vertical-align: middle; margin-right: 5px; display: inline-block;">account_circle</mat-icon>{{
        userOrganizationInfo.cmpnyName }}</div>
    </div>

    <div>{{ userOrganizationInfo.sosikiName }}</div>
    <div>{{ userName }}</div>
    <div><mat-icon style="vertical-align: middle; margin-right: 5px;">access_time</mat-icon>{{ businessDate |
      dateString}}</div>
  </div>

</mat-toolbar>